import React, { FC } from 'react';
import styles from '../LandingPageStep.scss';
import { HeaderLogo } from 'components/Header/HeaderLogo';
import { Button } from '@wix/design-system';
import { ArrowRight } from '@wix/wix-ui-icons-common';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import { useOrchestratorNavigation } from '@wix/gg-common-lib/orchestrator';
import { biEvents } from 'api/bi-events';
import { BI_BUTTON_NAME, BI_STEP_NAME } from 'config/bi-events';
import { StepId } from 'config/flow';

export const LandingPageStepContent: FC = () => {
  const { t } = useTranslation();
  const { next } = useOrchestratorNavigation();

  const handlePrimaryButtonClick = () => {
    biEvents.actionClicked({
      screenName: BI_STEP_NAME[StepId.LandingPage],
      button_name: BI_BUTTON_NAME.START_NOW,
    });
    next();
  };

  return (
    <div className={styles.landingPageStepContent}>
      <HeaderLogo />
      <p className={styles.landingPageStepContentTitle}>
        <Trans i18nKey="landing-page-step.title" components={{ br: <br /> }} />
      </p>
      <Button size="large" suffixIcon={<ArrowRight />} onClick={handlePrimaryButtonClick}>
        {t('landing-page-step.primary-button')}
      </Button>
      <p className={styles.landingPageStepContentDisclaimer}>{t('landing-page-step.disclaimer')}</p>
    </div>
  );
};
